import { render } from "./CarrierRequirementsStep.vue?vue&type=template&id=6a091a35"
import script from "./CarrierRequirementsStep.vue?vue&type=script&lang=ts"
export * from "./CarrierRequirementsStep.vue?vue&type=script&lang=ts"
script.render = render

export default script